import { CreateStyled } from '@emotion/styled';

export const transientPropOptions: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith('$'),
};
